import { Skel } from "../Skel";

// StorePicker while its candidate stores load: the same `.store-picker`
// frame (border, padding, paper-2), the head with the «Seleccionar
// todas» button box, and `.store-picker__option` rows with a checkbox box
// and the store name as a text bar in its real line box — so the picker
// replaces it without a shift. A div, not a fieldset: there is nothing
// to group or name yet, and the bars are aria-hidden.
type Props = {
  rows?: number;
};

const LABEL_WIDTHS = ["52%", "38%", "60%", "44%"] as const;

export function StorePickerSkel({ rows = 4 }: Props) {
  return (
    <div className="store-picker" aria-hidden="true">
      <div className="store-picker__head">
        <Skel variant="btn" />
      </div>
      <div className="store-picker__list">
        {Array.from({ length: rows }, (_, i) => (
          <div key={i} className="store-picker__option">
            <Skel width={13} height={13} />
            <Skel variant="text" width={LABEL_WIDTHS[i % LABEL_WIDTHS.length]} />
          </div>
        ))}
      </div>
    </div>
  );
}
